import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomStockProtectionOverviewList, SerialNoStatusResponseList } from './custom-stock-potection.models';

@Injectable()
export class CustomStockProtectionAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {}

  getStockProtection(): Observable<CustomStockProtectionOverviewList> {
    return this.http.get<CustomStockProtectionOverviewList>(
      this.occEndpoints.buildUrl('customStockProtectionOverview')
    );
  }

  searchStockProtection(productCode: string,processNumber: string, scenarioCode: string): Observable<CustomStockProtectionOverviewList> {
    const params = {
      productCode,
      processNumber,
      scenarioCode
    };
    return this.http.get<CustomStockProtectionOverviewList>(
      this.occEndpoints.buildUrl('customSearchStockProtection', {queryParams: params})
    );
  }

  getStockProtectionDetails(processNumber: string): Observable<SerialNoStatusResponseList> {
    const params = {
      processNumber: processNumber,
    };
    return this.http.get<SerialNoStatusResponseList>(
      this.occEndpoints.buildUrl('customStockProtectionDetails', {urlParams: params})
    );
  }

  updateSerialNumbers(processNumber: string, serialNumbers: string[]): Observable<SerialNoStatusResponseList>{
    const urlParams = {
      processNumber: processNumber,
    };

    const queryParams = {
      serialNumbers: serialNumbers,
    };

    return this.http.get<SerialNoStatusResponseList>(
      this.occEndpoints.buildUrl('customUpdatSerialNumbers', {urlParams: urlParams, queryParams: queryParams})
    );
  }

}
